import React, {FC} from 'react';

import {TeamModel} from '../../../../../libs/shared/core/src/models/api/teamModel';
import {InboxesPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {buildCustomViewCounterKey} from '../../../../helpers/counterHelpers';
import {buildCustomViewPath, VisualCustomView} from '../../../../helpers/models/customViewHelpers';
import {InboxesFiltersEnum} from '../../../../models/url/models/inboxesUrlModel';
import {WorkspaceDropReorderTeamViewHandler} from '../../../../store/data/workspace/reorder/types';
import {TeamWorkspaceCustomViewItemContainer} from './teamWorkspaceCustomViewItemContainer';

/*
 * Props.
 */

interface WorkspaceCustomViewsProps {
  panelId: InboxesPanelId;
  visualCustomViews: ReadonlyArray<VisualCustomView>;
  hasEditPermission: boolean;
  isNotReorderable?: boolean;
  team: TeamModel;
  shouldAlphabetizeWorkspace: boolean;
  onDropReorderTeamView: WorkspaceDropReorderTeamViewHandler;
  shouldHideTeamTagCounters: boolean;
}

/*
 * Component.
 */

export const TeamWorkspaceCustomViews: FC<WorkspaceCustomViewsProps> = ({
  panelId,
  visualCustomViews,
  team,
  hasEditPermission,
  isNotReorderable,
  onDropReorderTeamView,
  shouldAlphabetizeWorkspace,
  shouldHideTeamTagCounters,
}) => (
  <>
    {visualCustomViews.map((customView, index) => {
      const customViewPath = buildCustomViewPath(customView.id, {
        isTeammateView: false,
        filter: InboxesFiltersEnum.OPEN,
      });

      const lastIndex = visualCustomViews.length - 1;
      return (
        <TeamWorkspaceCustomViewItemContainer
          panelId={panelId}
          team={team}
          key={customView.id}
          customView={customView}
          hasEditPermission={hasEditPermission}
          counterKey={buildCustomViewCounterKey(customView.uid, customView.type, shouldHideTeamTagCounters)}
          to={customViewPath}
          isLastInList={index === lastIndex}
          shouldAlphabetizeWorkspace={shouldAlphabetizeWorkspace}
          onDropReorderTeamView={onDropReorderTeamView}
          isNotDraggable={isNotReorderable}
        />
      );
    })}
  </>
);
